// Wilma owns the queue; the phone system only places calls and reports what happens to them. The
// live queue talks to it through this interface so moving from click-to-call (phase 1) to the 3CX
// Call Control API (phase 3) changes the adapter, not the screen.

export type CallEvent =
  | { type: "ringing" }
  | { type: "answered" }
  | { type: "ended"; reason: "hangup" | "no-answer" | "busy" | "failed" };

export interface TelephonyCapabilities {
  /** The phone system tells us when a call is answered and ends. False means the agent says so. */
  reportsCallEvents: boolean;
  hold: boolean;
  transfer: boolean;
  hangup: boolean;
}

export interface TelephonyAdapter {
  readonly capabilities: TelephonyCapabilities;
  dial(phoneNumber: string): void;
  hold(): void;
  transfer(target: string): void;
  hangup(): void;
  /** Returns an unsubscribe function. */
  onCallEvent(listener: (event: CallEvent) => void): () => void;
}

/** A number in the form a tel: link wants: digits and a leading +, nothing else. */
export function telHref(phoneNumber: string): string {
  const cleaned = phoneNumber.trim().replace(/[^\d+]/g, "");
  return `tel:${cleaned}`;
}

/**
 * Phase 1: dialling opens a tel: link, which the agent's 3CX client picks up. Wilma learns nothing
 * back, so the agent moves the call along themselves and hold, transfer and hang-up stay in 3CX.
 */
export class TelLinkAdapter implements TelephonyAdapter {
  readonly capabilities: TelephonyCapabilities = {
    reportsCallEvents: false,
    hold: false,
    transfer: false,
    hangup: false,
  };

  constructor(private readonly open: (href: string) => void = (href) => window.open(href, "_self")) {}

  dial(phoneNumber: string) {
    if (!phoneNumber?.trim()) return;
    this.open(telHref(phoneNumber));
  }

  hold() {}

  transfer() {}

  hangup() {}

  onCallEvent() {
    return () => {};
  }
}
